import { flatten, last } from "lodash";
import get from "lodash/get";
import useSWRInfinite from "swr/infinite";

import { useApplicationContext } from "contexts/app";

const useFetchRecords = (path: string, params: any, hasPermission?: boolean) => {
  const { httpClient } = useApplicationContext();

  const recordsURL: any = new URL(`${httpClient?.basePath}${path}`);
  recordsURL.search = new URLSearchParams(params);

  const {
    data: records,
    mutate,
    error,
  } = useSWRInfinite(
    // @ts-ignore
    hasPermission && path && httpClient?.getKey(recordsURL.href),
    httpClient?.swrInfiniteFetcher || null,
    {
      initialSize: 100,
    }
  );

  return {
    records: flatten(records?.map((item) => item?.data)),
    count: get(last(records), "count"),
    loading: hasPermission === false ? hasPermission : records === undefined && error === undefined,
    mutate,
  };
};

export { useFetchRecords };
